import { render, staticRenderFns } from "./GradeSelector.vue?vue&type=template&id=8153a7f4&scoped=true&"
import script from "./GradeSelector.vue?vue&type=script&lang=js&"
export * from "./GradeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8153a7f4",
  null
  
)

export default component.exports